import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

const CenterBox = ({ children, ...props }) => {
  return (
    <Box
      sx={{
        marginTop: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
      {...props}
    >
      { children }
    </Box>
  );
};

CenterBox.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CenterBox;
